const CallQueueIndicator = ({ count = 0 }) => {

    const showFullList = count > 0 && count <= 5;
    const showCollapsed = count > 5;

    console.log("CallQueueIndicator Rendered with count:", count);

    return (
        <div>

            {/* TOP YELLOW MESSAGE */}
            {count > 0 && (
                <div
                    className="vm_custom_body4"
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        marginBottom: "6px",
                        color: "#f27e0d",
                        fontWeight: 600,
                    }}
                >
                    <div
                        style={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            background: "#f27e0d",
                        }}
                    />
                    There are <span style={{
                        fontWeight: 600,
                        color: "#f27e0d",
                        animation: "blink-call 1s infinite",
                    }}>
                        {"(" + count + ")"}
                    </span> calls ahead in the queue
                </div>
            )}

            {/* ===== CASE 1: 1 to 5 ===== */}
            {showFullList &&
                Array.from({ length: count - 1 }).map((_, index) => {
                    const num = count - 1 - index;

                    return (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                marginBottom: "6px",
                            }}
                        >
                            <div
                                style={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: "50%",
                                    background: "#aaaaaa",
                                }}
                            />
                            <span className="vm_custom_body4" style={{ color: "#555555",borderRadius:"4px" }}>
                                {num} Call Ahead
                            </span>
                        </div>
                    );
                })}

            {/* ===== CASE 2: GREATER THAN 5 ===== */}
            {showCollapsed && (
                <>
                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            marginBottom: "6px",
                        }}
                    >
                        <div
                            style={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                background: "#aaaaaa",
                            }}
                        />
                        <span className="vm_custom_body4" style={{ color: "#555555" }}>
                            {count - 1} Call Ahead
                        </span>
                    </div>

                    <div
                        style={{
                            marginBottom: "6px",
                            marginLeft: "3px",
                            color: "#aaaaaa",
                            fontSize: "18px",
                            lineHeight: "8px",
                        }}
                    >
                        •<br />•<br />•
                    </div>
                </>
            )}

            {/* GREEN ON CALL */}
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                }}
            >
                <div
                    className="blinkRequest"
                    style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        background: "#008800",
                    }}
                />
                <span className="vm_custom_body4" style={{ color: "#008800" }}>
                    On Call
                </span>
            </div>
        </div>
    );
};


export default CallQueueIndicator;
